export function getChaletImages(chalet) {
  const desktop =
    Array.isArray(chalet?.images) && chalet.images.length > 0
      ? chalet.images
      : chalet?.imageUrl
        ? [chalet.imageUrl]
        : [];

  const mobileFromDoc =
    Array.isArray(chalet?.imagesMobile) && chalet.imagesMobile.length > 0
      ? chalet.imagesMobile
      : chalet?.imageUrlMobile
        ? [chalet.imageUrlMobile]
        : [];

  const mobile = desktop.map((url, index) => mobileFromDoc[index] || url);

  return { desktop, mobile };
}

export function getChaletCover(chalet) {
  const { desktop, mobile } = getChaletImages(chalet);
  return {
    desktop: desktop[0] || "",
    mobile: mobile[0] || desktop[0] || "",
  };
}
